import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20pattern%20with%20flowing%20creative%20energy%20waves%2C%20soft%20orange%20and%20amber%20gradients%2C%20modern%20minimalist%20tech%20background%2C%20cinematic%20lighting%2C%20clean%20and%20professional%20aesthetic&width=1800&height=700&seq=cta-bg-yiqicao&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-950/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          准备好开启<span className="text-primary-400">团队创作</span>了吗？
        </h2>
        <p className="text-base text-white/70 mb-10 leading-relaxed max-w-xl mx-auto">
          加入50万+创作者的大家庭，体验前所未有的视频协作效率。免费开始，无需信用卡。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            免费开始使用
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/25 text-white font-medium text-sm hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            查看教程
            <i className="ri-book-open-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}